export class InitialIntegrationReducer {
    isLoading; // LoadingSpinner Import- / IntegrationScreen
    isCreateLoading; // LoadingSpinnerButton in createConfigurationModal
    isUpdateLoading; // LoadingSpinnerButton in advancedSettingsModal & ImportScreenHeader -> "save"
    isDeleteLoading; // LoadingSpinnerButton in deleteConfigurationModal
    isImportLoading; // LoadingSpinnerButton in ImportRequestCards /ImportDateSelection

    createConfigurationModal; // IntegrationScreen
    deleteConfigurationModal; // IntegrationScreen
    advancedSettingsModal; // ImportScreen

    submitted; // ImportScreen
    unsavedChanges; // ImportScreen

    configurations; // IntegrationScreen
    newConfiguration; // IntegrationScreen
    configurationToBeDeleted; // IntegrationScreen

    configuration; // ImportScreen as backup to override editConfiguration -> cancel edit use case
    editConfiguration; // ImportScreen -> all changes in accounting or advanced settings -> will be the updateRequestBody

    importRequest; // ImportScreen

    successMessage; // main CRUD successMessages displayed on Import- / IntegrationScreen
    importSuccessMessage; // importSuccess should be displayed in ImportRequestCards/ImportDateSelection
    errorMessage; // all errorMessages displayed on Import- / IntegrationScreen
    warningMessage; // all warningMessages displayed on Import- / IntegrationScreen
    createErrorMessage; // errorMessage displayed in createConfigurationModal
    updateErrorMessage; // errorMessage displayed in advancedSettingsModal or on ImportScreen
    deleteErrorMessage; // errorMessage displayed in deleteConfigurationModal
    importErrorMessage; // errorMessage displayed in ImportDataCards

    constructor() {
        this.isLoading = false;
        this.isCreateLoading = false;
        this.isUpdateLoading = false;
        this.isDeleteLoading = false;
        this.isImportLoading = false;

        this.createConfigurationModal = false;
        this.advancedSettingsModal = false;
        this.deleteConfigurationModal = false;

        this.unsavedChanges = false;
        this.submitted = false;

        this.commons = undefined;
        this.configurations = [];
        this.newConfiguration = null;
        this.configuration = null;
        this.editConfiguration = null;
        this.configurationToBeDeleted = null;

        this.importRequest = null;

        this.successMessage = null;
        this.errorMessage = null;
        this.warningMessage = null;
        this.createErrorMessage = null;
        this.updateErrorMessage = null;
        this.deleteErrorMessage = null;
        this.importErrorMessage = null;
        this.importSuccessMessage = null;

        this.cloneConfigurationModal = false;
        this.configurationToBeCloned = null;
        this.cloneOrganizations = [];
        this.cloneSourceConfigurations = [];
        this.cloneSourceConfigsLoading = false;
        this.goldStandardOptions = [];
        this.isCloneLoading = false;
        this.cloneErrorMessage = null;
        this.cloneSuccessMessage = null;
    }
}
